import { OrderAccess } from '@/screens/OrdersPage/ui';

export default OrderAccess;
